export const appsAppGroupsWithPermissionCacheKeys = "/apps/app_groups_with_permission/:permission";
